import { h } from 'preact';

const ItemPlaceholderFiatV2 = () => (
  <div class="new-vehicles-lazy__carousel-placeholder-item">
    <div
      className={`ph-item new-vehicles-lazy__placeholder-card`}
      style={{ width: '100%' }}
    >
      <div className="ph-col-12">
        <div className="ph-picture" />
        <div className="ph-row">
          <div className="ph-col-2 empty" />
          <div className="ph-col-8 big" />
          <div className="ph-col-2 empty" />
        </div>

        <div className="ph-row">
          <div className="ph-col-2 empty" />
          <div className="ph-col-8 big" />
          <div className="ph-col-2 empty" />
        </div>
      </div>
    </div>
  </div>
);

export default ItemPlaceholderFiatV2;
